import { chakra, Box, Flex } from "@chakra-ui/react";
import { useState } from "react";


interface CustomCheckboxProps {
  label: string;
  onChange: (isChecked:boolean) => void; 
  isChecked:boolean;
}

export default function CustomCheckbox(props:CustomCheckboxProps) {
  const [isChecked, setIsChecked] = useState(props.isChecked || false);
  const [isEditMode,setIsEditMode]=useState(false);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
    props.onChange && props.onChange(!isChecked);
  };

  return (
    <chakra.label
      display="flex"
      flexDirection="row"
      alignItems="center"
      gridColumnGap={2}
      w={"full"}
      rounded="lg"
      px={3}
      py={1}
      cursor={ "pointer"} 
      onClick={ toggleCheckbox} 
    >
      <Flex
        alignItems='center'
        justifyContent='center'
        border='2px solid'
        borderColor='black'
        w={4}
        h={4}
      >
        {isChecked && <Box w={2} h={2} bg="black" />}
      </Flex>
      {props.label}
    </chakra.label>
  );
}
